<template lang="pug">
.keyword-input
  aiq-keyword-list(:list="list"
                  :deletableExcept="deletableExcept"
                  :deletable="deletable"
                  @deleteItem="deleteItem"
                  @click="focusKeywordInput()")
    aiq-input.add-keyword(v-model="newKeyword"
                          @keyup.enter="createItem"
                          :maxlength="itemMaxLength"
                          @blur="reset")
</template>

<script>
import KeywordList from './KeywordList.vue';

export default {
  name: 'aiq-keyword-input',
  components: {
    KeywordList,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    deletableExcept: {
      type: Array,
      default: () => [],
    },
    deletable: {
      type: Boolean,
      default: () => false,
    },
    itemMaxLength: {
      type: Number,
      default: () => 100,
    },
  },
  data() {
    return {
      newKeyword: '',
    };
  },
  methods: {
    createItem() {
      const keyword = this.newKeyword.trim();
      if (!keyword.length) {
        return;
      }
      this.$emit('createItem', keyword);
      this.newKeyword = '';
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },
    focusKeywordInput() {
      this.$el.querySelector('.add-keyword').classList.add('active');
      this.$el.querySelector('.el-input__inner').focus();
    },
    reset() {
      this.$el.querySelector('.add-keyword').classList.remove('active');
      this.newKeyword = '';
    },
  },
};
</script>

<style lang="scss" scoped>
$keyword-padding: 6px;

.keyword-input {
  padding-left: $keyword-padding;
  padding-right: $keyword-padding;
  border: 1px solid #bfcbd9;
  border-radius: 4px;
  transition: border 0.3s;
  cursor: text;

  &:focus-within {
    border-color: #20a0ff;
  }

  .el-tag {
    height: auto;
    min-height: 24px;
    margin-right: 6px;
    margin-bottom: 6px;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }
}
</style>

<style lang="scss">
/* todo remove !important after phase out vue material */
.keyword-input {
  .add-keyword {
    flex-grow: 1;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    flex-basis: 50px;
    top: -2px;
    display: none;

    &.active {
      display: inherit;
    }

    .el-input__inner {
      height: 24px;
      line-height: 24px;
      padding-left: 0;
      border: 0;
      background-color: transparent;
    }
  }
}
</style>
